import React, { useEffect, useState } from "react";
import { api } from "@finance/lib/api";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@finance/components/ui/select";
import { QuickAddButton } from "@finance/components/QuickAdd";

let _cache = null;

// Currency dropdown backed by the Currencies manager (/currencies) — every currency available everywhere.
// Includes an inline "＋" to create a new currency without leaving the flow.
export function CurrencySelect({ value, onValueChange, testid, disabled, className, allowCreate = true }) {
  const [curs, setCurs] = useState(_cache || []);
  const refetch = () => api.get("/currencies").then((r) => { _cache = r.data || []; setCurs(_cache); }).catch(() => {});
  useEffect(() => { if (!_cache) refetch(); }, []);

  const select = (
    <Select value={value} onValueChange={onValueChange} disabled={disabled}>
      <SelectTrigger className={className} data-testid={testid}><SelectValue placeholder="Currency" /></SelectTrigger>
      <SelectContent className="max-h-72">
        {(curs.length ? curs : [{ code: value || "TZS" }]).map((c) => (
          <SelectItem key={c.code} value={c.code}>{c.code}{c.symbol ? ` (${c.symbol})` : ""}</SelectItem>
        ))}
      </SelectContent>
    </Select>
  );

  if (!allowCreate || disabled) return select;
  return (
    <div className="flex items-center gap-1">
      <div className="flex-1">{select}</div>
      <QuickAddButton type="currency" onCreated={(c) => { _cache = null; refetch().then(() => c?.code && onValueChange?.(c.code)); }} />
    </div>
  );
}

export default CurrencySelect;
